export default "__VITE_ASSET__c497d814__"